import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/HomePage.vue';
import LoginView from '../views/LoginView.vue';
import ServiceView from '../views/ServiceView.vue';
import BusinessView from '../views/BusinessView.vue';
import BusinessDetailView from '../views/BusinessDetailView.vue';
import RecoverPasswordView from '../views/RecoverPasswordView.vue';
import UserView from '../views/UserView.vue';
import UserCalendarView from '../views/UserCalendarView';
import ServiceDetailView from '../views/ServiceDetailView.vue';
import TaskView from '../views/TaskView';
import BusinessDocumentsView from '../views/BusinessDocumentsView';
import BusinessFoldersView from '../views/BusinessFoldersView';
import TaskTrackingView from '../views/TaskTrackingView';
import HomeClientView from '../views/HomeClientView';
import NotesView from '../views/NotesView';
import TaskDetailView from '../views/TaskDetailView'
import BusinessGroupView from '../views/BusinessGroupView';
import BusinessGroupDetailView from '../views/BusinessGroupDetailView'
import EmailView from '../views/EmailView'

Vue.use(VueRouter);

const routes = [
  {
    path: '/calendario',
    name: 'UserCalendar',
    component: UserCalendarView,
    meta: {
      isPublic: false,
      roles: ['owner', 'collaborator']
    }
  },
  {
    path: '/documentos',
    name: 'BusinessDocuments',
    component: BusinessDocumentsView,
    meta: {
      isPublic: false,
      roles: ['owner', 'collaborator']
    }
  },
  {
    path: '/documentos/empresa/:businessId',
    name: 'BusinessFolders',
    component: BusinessFoldersView,
    meta: {
      isPublic: false,
      roles: ['owner', 'collaborator']
    }
  },
  {
    path: '/documentos/empresa/:businessId/carpeta/:folderId',
    name: 'BusinessFolder',
    component: BusinessFoldersView,
    meta: {
      isPublic: false,
      roles: ['owner', 'collaborator']
    }
  },
  {
    path: '/servicios/:id',
    name: 'ServiceDetail',
    component: ServiceDetailView,
    meta: {
      isPublic: false,
      roles: ['owner']
    }
  },
  {
    path: '/empresas/:id',
    name: 'BusinessDetail',
    component: BusinessDetailView,
    meta: {
      isPublic: false,
      roles: ['owner','collaborator']
    }
  },
  {
    path: '/empresas',
    name: 'Business',
    component:BusinessView,
    meta: {
      isPublic: false,
      roles: ['owner','collaborator']
    }
  },
  {
    path: '/servicios',
    name: 'Services',
    component:ServiceView,
    meta: {
      isPublic: false,
      roles: ['owner']
    }
  },
  {
    path: '/login',
    name: 'Login',
    component:LoginView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      isPublic: false,
      roles: ['owner', 'collaborator', 'client']
    }
  },
  {
    path: '/recuperar-contraseña/:token?',
    name: 'Recover password',
    component:RecoverPasswordView,
    meta: {
      isPublic: true
    }
  },
  {
    path: '/usuarios',
    name: 'Users',
    component: UserView,
    meta: {
      isPublic: false,
      roles: ['owner']
    }
  },
  {
    path: '/tareas',
    name: 'Tasks',
    component:TaskView,
    meta: {
      isPublic: false,
      roles: ['owner']
    }
  },
  {
    path: '/tareas/:taskId',
    name: 'TaskDetail',
    component: TaskDetailView,
    meta: {
      isPublic: false,
      roles: ['owner']
    }
  },
  {
    path: '/seguimiento-tareas',
    name: 'TasksTracking',
    component:TaskTrackingView,
    meta: {
      isPublic: false,
      roles: ['owner','collaborator']
    }
  },
  {
    path: '/carpeta/:folderId/año/:year/mes/:month',
    name: 'ClientFolder',
    component:HomeClientView,
    meta: {
      isPublic: false,
      roles: ['client']
    }
  },
  {
    path: '/notas',
    name: 'Notes',
    component: NotesView,
    meta: {
      isPublic: false,
      roles: ['owner','collaborator']
    }
  },
  {
    path: '/grupos-empresas',
    name: 'BusinessGroup',
    component: BusinessGroupView,
    meta: {
      isPublic: false,
      roles: ['owner','collaborator']
    }
  },
  {
    path: '/grupos-empresas/:groupId',
    name: 'BusinessGroupDetail',
    component: BusinessGroupDetailView,
    meta: {
      isPublic: false,
      roles: ['owner']
    }
  },
  {
    path: '/email',
    name: 'EmailView',
    component: EmailView,
    meta: {
      isPublic: false,
      roles: ['owner']
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

export default router;
